<template>
  <div class="wrap-collapse">
    <base-button w="100%" bg="transparent" data-bs-toggle="collapse" :data-bs-target="`#${id}`" aria-expanded="false" :aria-controls="id" d="flex" justify="between" class="p-0 collapsed" no-focus>
      <cl-title tag="h5">{{ title }}</cl-title>
      <i class="fas fa-caret-down fs-2"></i>
    </base-button>
    <div class="collapse" :id="id">
      <div class="pt-4 mt-3">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/BaseButton'
import ClTitle from '@/components/text/BaseTitle'
export default {
  components: {
    BaseButton,
    ClTitle
  },
  props: {
    id: {
      type: String,
      default: 'collapseExample'
    },
    title: String
  }
}
</script>

<style>

</style>